// extracted by mini-css-extract-plugin
module.exports = {"notification":"notify_notification__IDzc0"};